import { useEffect } from 'react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { useCurrentStaff } from '@/hooks/useStaffAuth'
import { LoginForm } from '@/components/auth/LoginForm'

const STAFF_RESTAURANT_KEY = 'digimataam_staff_restaurant'

export default function StaffLogin() {
  const navigate = useNavigate()
  const { data: staff } = useCurrentStaff()
  const search = useSearch({ from: '/staff-login' })

  // Get restaurant ID from query params or localStorage
  const restaurantFromUrl = (search as any)?.restaurant as string | undefined
  const restaurantFromStorage = typeof window !== 'undefined'
    ? localStorage.getItem(STAFF_RESTAURANT_KEY)
    : null
  const restaurantId = restaurantFromUrl || restaurantFromStorage || ''

  // Persist restaurant ID when visiting with URL param
  useEffect(() => {
    if (restaurantFromUrl) {
      localStorage.setItem(STAFF_RESTAURANT_KEY, restaurantFromUrl)
    }
  }, [restaurantFromUrl])

  // Redirect if already authenticated
  useEffect(() => {
    if (staff) {
      if (staff.role === 'server') {
        navigate({ to: '/staff-server' })
      } else if (staff.role === 'kitchen') {
        navigate({ to: '/staff-kitchen' })
      } else if (staff.role === 'printer') {
        navigate({ to: '/staff-printer' })
      }
    }
  }, [staff, navigate])

  if (!restaurantId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="text-center max-w-md">
          <h1 className="text-2xl font-bold mb-2">Invalid Login Link</h1>
          <p className="text-muted-foreground">
            Please use the login link provided by your administrator.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <LoginForm restaurantId={restaurantId} isStaffLogin={true} />
    </div>
  )
}
